export const STANDARD_BAGS_PER_PALLET = 11;
export const ROSSI_BAGS_PER_PALLET = 6;

const ROSSI_CARRIER_CODES = new Set(["rosi", "rssi"]);

type DeliveryLike = {
  carrier?: unknown;
  carrierCode?: unknown;
  carrierName?: unknown;
  deliveryService?: unknown;
  shippingMetadata?: unknown;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function normalizeCarrierValue(value: unknown): string {
  if (typeof value !== "string" && typeof value !== "number") return "";
  return String(value).trim().toLowerCase();
}

function normalizeCarrierCode(value: string): string {
  return value.replace(/[^a-z0-9]/g, "");
}

function hasRossiName(value: string): boolean {
  return /(^|[^a-z0-9])rossi([^a-z0-9]|$)/.test(value);
}

export function isRossiCarrier(delivery?: DeliveryLike | null): boolean {
  if (!delivery) return false;

  const metadata = isRecord(delivery.shippingMetadata) ? delivery.shippingMetadata : {};
  const candidates = [
    delivery.carrierName,
    delivery.deliveryService,
    delivery.carrier,
    delivery.carrierCode,
    metadata.carrierName,
    metadata.carrier,
    metadata.carrierCode,
    metadata.carrier_code,
    metadata.shippeekCode,
  ];

  return candidates.some((candidate) => {
    const normalized = normalizeCarrierValue(candidate);
    if (!normalized) return false;
    if (hasRossiName(normalized)) return true;
    return ROSSI_CARRIER_CODES.has(normalizeCarrierCode(normalized));
  });
}

export function getBagsPerPalletForDelivery(delivery?: DeliveryLike | null): number {
  return isRossiCarrier(delivery) ? ROSSI_BAGS_PER_PALLET : STANDARD_BAGS_PER_PALLET;
}

export function calculatePalletCountForDelivery(
  totalBags: number,
  delivery?: DeliveryLike | null,
): number {
  const normalizedTotalBags = Math.max(0, Number(totalBags) || 0);
  if (normalizedTotalBags === 0) return 0;
  return Math.ceil(normalizedTotalBags / getBagsPerPalletForDelivery(delivery));
}
